import { useQuery } from '@tanstack/react-query';
import type { GetPendingRxChangesDetailedParams } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchPendingRxChangesDetailed } from '../api/getPendingRxChangesDetailed.js';
import { rxKeys } from './keys.js';

export function pendingRxChangesDetailedQueryDefinition(
  params?: GetPendingRxChangesDetailedParams
) {
  return {
    queryKey: rxKeys.pendingRxChangesDetailed(params),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPendingRxChangesDetailed(params, signal),
    meta: {
      toast: {
        title: 'Could not load detailed pending RxChanges',
        description: 'Detailed pending RxChanges could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePendingRxChangesDetailedQuery(params?: GetPendingRxChangesDetailedParams) {
  return useQuery(pendingRxChangesDetailedQueryDefinition(params));
}
